import { YouWinModalActionType } from '../../types/youWinModalType'

export const closeYouWinModal = () => {
    return {type: YouWinModalActionType.CLOSE_YOU_WIN_MODAL, data: {}}
}

export const openYouWinModal = (data : any) => {
    return {type: YouWinModalActionType.OPEN_YOU_WIN_MODAL, data: data}
}
